module.exports = __webpack_public_path__ + "static/media/8@3x.f7081f1d.png";